import { render } from "./UserPasswordIndex.vue?vue&type=template&id=2f896c93"
import script from "./UserPasswordIndex.vue?vue&type=script&lang=js"
export * from "./UserPasswordIndex.vue?vue&type=script&lang=js"

import exportComponent from "/Users/furkanyesil/Projects/fair-mieten-mg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__